import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDependabotComponent } from './simple-icons-dependabot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDependabotComponent ],
    exports:      [ SimpleIconsDependabotComponent ],
    bootstrap:    []
})
export class SimpleIconsDependabotModule {}
